import { render } from "./VenueLabs.vue?vue&type=template&id=332c169d"
import script from "./VenueLabs.js?vue&type=script&lang=js"
export * from "./VenueLabs.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__